import React from "react";
import { useSelector } from "react-redux";
import {
  removeCurrencySign,
  formatCurrency,
  percentageSign,
} from "../../../Constants/utils";
import { getPercentageDiscount } from "../../../Redux/features/Dashboard/Charts/percentageDiscountChartSlice";
import { CommonChart } from "./CommonChart";

export const PercentageDiscountChart = ({
  merchantId,
  activeType,
  presentDate,
  percentageDiscountChartInView,
  percentageDiscountChartRef,
  selectedOutletIds = [],
}) => {
  const percentageDiscountChart = useSelector(
    (state) => state.percentageDiscountChart
  );
  const chartKey = "percentageDiscountChart";

  return (
    <>
      <CommonChart
        componentRef={percentageDiscountChartRef}
        activeType={activeType}
        formatFunction={removeCurrencySign}
        presentDate={presentDate}
        // sliceCallback={getPercentageDiscount}
        sliceCallback={(data) =>
          getPercentageDiscount({ data, isRuntime: false })
        }
        sliceCallDiscountPercentageData={(data) =>
          getPercentageDiscount({ data, isRuntime: true })
        }
        yAxisText={"Discounts Given (Percentage)"}
        reduxState={percentageDiscountChart}
        reduxStateKey={"percentageDiscountData"}
        valueKey={"discount_in_per"}
        // reduxStateKey={"discountData"}
        reduxStateTotalKey={"totalPercentageDiscount"}
        // valueKey={"total_discount"}
        chartKey={chartKey}
        merchantId={merchantId}
        chartInView={percentageDiscountChartInView}
        title={"Discounts Given (Percentage)"}
        // totalValueFunction={formatCurrency}
        totalValueFunction={percentageSign}
        selectedOutletIds={selectedOutletIds}
      />
    </>
  );
};
